import { render, staticRenderFns } from "./organization-selector.vue?vue&type=template&id=466e4b18"
import script from "./organization-selector.vue?vue&type=script&lang=js"
export * from "./organization-selector.vue?vue&type=script&lang=js"
import style0 from "./organization-selector.vue?vue&type=style&index=0&id=466e4b18&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports